import { css } from 'lit-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';
import { mobile, tablet } from '../utils';

export const styles = css`
  :host {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-self: center;
    font-size: 12px;
    letter-spacing: 0.2px;
    line-height: 1.2;
    align-self: start;
  }

  ::slotted(a) {
    width: 34px;
    height: 34px;
    display: block;
    overflow: hidden;

    font-size: 0;
    line-height: 0;

    color: transparent;

    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 4px;

    user-select: none;
  }
  
  ${mobile(css`
    :host {
        padding-bottom: 15px;
        }
    `)}
  `;
